import "../../resources/css/bootstrap-vendor.css";
import "../../resources/less/Globals.less";
import "../../resources/less/normalize.less";
import "../../resources/less/Troubadour/troubadourTheme.less";
import "../../resources/less/components/Buttons/CommonButtons.less";
import "../../resources/less/Info/Components/Buttons.less";
import "../../resources/less/Admin/components/Footer.less";
import "../components/FontAwesomeConfig";
import ViewportZoom from "../ViewportZoom";
import InitBugsnag from "../BugsnagConfig";
import InitInpReporting from "../InpReporting";
import "../jquery-global";

class InfoMain {
  constructor() {
    InitBugsnag();
    // The info pages are their own CrUX origin; reporting here too settles which origin
    // a field INP number belongs to.
    InitInpReporting();
    void ViewportZoom();
  }
}

$(window).on("load", () => {
  new InfoMain();
});
